function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var HeaderMenuTemplate = require('./header-menu.template');
var HeaderMenu = /*#__PURE__*/function () {
  function HeaderMenu(app, mod) {
    _classCallCheck(this, HeaderMenu);
    this.app = app;
    this.mod = mod;
    this.events = null;
  }
  return _createClass(HeaderMenu, [{
    key: "render",
    value: function render() {
      var _this$events,
        _document$querySelect,
        _this = this;
      (_this$events = this.events) === null || _this$events === void 0 || _this$events.abort();
      (_document$querySelect = document.querySelector('.explorer-header-menu')) === null || _document$querySelect === void 0 || _document$querySelect.remove();
      var host = document.querySelector('.explorer-utility-inner');
      if (!host) return;
      host.insertAdjacentHTML('beforeend', HeaderMenuTemplate());
      var root = host.querySelector('.explorer-header-menu');
      var toggle = root.querySelector('button');
      var navigation = root.querySelector('nav');
      var setOpen = function setOpen(open) {
        toggle.setAttribute('aria-expanded', String(open));
        navigation.hidden = !open;
      };
      this.events = new AbortController();
      var options = {
        signal: this.events.signal
      };
      toggle.addEventListener('click', function () {
        return setOpen(navigation.hidden);
      }, options);
      root.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && !navigation.hidden) {
          event.preventDefault();
          event.stopPropagation();
          setOpen(false);
          toggle.focus();
        }
      }, options);
      root.addEventListener('focusout', function (event) {
        if (!root.contains(event.relatedTarget)) setOpen(false);
      }, options);
      document.addEventListener('click', function (event) {
        if (!root.contains(event.target)) setOpen(false);
      }, options);
      navigation.addEventListener('click', function (event) {
        var link = event.target.closest('[data-explorer-header-nav]');
        if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        event.preventDefault();
        event.stopPropagation();
        setOpen(false);
        toggle.focus();
        var view = link.dataset.explorerHeaderNav;
        if (view === 'chain') _this.mod.renderChain('');
        if (view === 'supply') _this.mod.renderSupply({
          pushState: true,
          animate: true
        });
        if (view === 'holders') _this.mod.renderHolders();
      }, options);
    }
  }]);
}();
module.exports = HeaderMenu;